module.exports = __webpack_public_path__ + "static/media/01-austen.6bfe9982.jpg";